import { Flex, Link, Text } from '@chakra-ui/react';
import { _js } from '@ifixit/localize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/pro-regular-svg-icons/faTrophy';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons/faPenToSquare';

export const NavigationButtonProps = {
   fontWeight: 'bold',
   fontSize: '14px',
   color: 'brand.500',
   variant: 'solid',
   backgroundColor: 'transparent',
};

// Todo: replace /Leaderboard with a GuideURI
export function Navigation({ editUrl, usersUrl }: { editUrl?: string; usersUrl: string }) {
   return (
      <Flex
         direction="row"
         justify="space-between"
         align="center"
         h={10}
         mt={{ base: '24px', lg: 'unset' }}
      >
         <LeaderboardButton usersUrl={usersUrl} />
         {editUrl && <ModeToggleButton editUrl={editUrl} />}
      </Flex>
   );
}

const LeaderboardButton = ({ usersUrl }: { usersUrl: string }) => (
   <Link {...NavigationButtonProps} href={usersUrl}>
      <FontAwesomeIcon icon={faTrophy} />
      <Text ml={2} display="inline">
         {_js('Leaderboard')}
      </Text>
   </Link>
);

const ModeToggleButton = ({ editUrl }: { editUrl: string }) => (
   <Link {...NavigationButtonProps} href={editUrl}>
      <FontAwesomeIcon icon={faPenToSquare} />
      <Text ml={2} display="inline">
         {_js('Edit')}
      </Text>
   </Link>
);
